<div class="row">
    <div class="col-12">
        <div class="mat-h3">Monthly Fee Charges</div>
    </div>
</div>
<div class="row">
    <div class="col-lg-4 col-md-12">
        <mat-form-field class="search">
            <input matInput type="text" class="ml-4" placeholder="Search account ID"
                [(ngModel)]="accountIdFilter">
            <span class="mdi mdi-magnify" matPrefix></span>
        </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-12">
        <mat-form-field appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="statusFilter">
                <mat-option *ngFor="let option of statusOptions" [value]="option.value">
                    {{option.label}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-12">
        <mat-form-field appearance="outline">
            <mat-label>Period</mat-label>
            <input matInput [value]="periodYearMonthFilter" readonly placeholder="Select month and year"
                (click)="periodPicker.open()">
            <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
        </mat-form-field>
        <input class="period-picker-anchor" [matDatepicker]="periodPicker" [ngModel]="periodDate" tabindex="-1"
            aria-hidden="true">
        <mat-datepicker #periodPicker startView="year"
            (monthSelected)="setPeriodMonth($event, periodPicker)"></mat-datepicker>
    </div>
</div>
<div class="row">
    <div class="col-lg-4 col-md-12">
        <mat-form-field appearance="outline">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-12">
        <mat-form-field appearance="outline">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-12">
        <div class="action-buttons">
            <button mat-flat-button color="primary" (click)="applyFilters()">Apply Filters</button>
            @if (hasFilters) {
            <button mat-stroked-button color="primary" (click)="clearFilters()">
                <span class="mdi mdi-close" matPrefix></span>
                Clear
            </button>
            }
            @if (selection.selected.length > 0) {
            <button mat-flat-button color="primary" (click)="retrySelected()">
                <span class="mdi mdi-refresh"></span>
                Retry Selected ({{selection.selected.length}})
            </button>
            }
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12">
        @if (isLoading) {
        <custom-content-loader type="list"></custom-content-loader>
        }
        <div [ngClass]="{hidden: isLoading, 'table-section': true, 'pb-3': true}">
            <table mat-table [dataSource]="dataSource" class="width-100 mb-2" multiTemplateDataRows matSort
                [matSortActive]="sortActive" [matSortDirection]="sortDirection" (matSortChange)="onSortData($event)">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox color="primary" (change)="$event ? toggleAllRows() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                            (change)="$event ? toggleRow(element) : null" [checked]="selection.isSelected(element)">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
                    <td mat-cell *matCellDef="let element" class="td-width ellipsis">{{element.id}}</td>
                </ng-container>

                <ng-container matColumnDef="pismoAccountId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Account ID</th>
                    <td mat-cell *matCellDef="let element" class="td-width ellipsis">{{element.pismoAccountId}}</td>
                </ng-container>

                <ng-container matColumnDef="periodYearMonth">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Period</th>
                    <td mat-cell *matCellDef="let element">{{element.periodYearMonth}}</td>
                </ng-container>

                <ng-container matColumnDef="computedAmount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Computed</th>
                    <td mat-cell *matCellDef="let element">{{formatAmount(element.computedAmount)}}</td>
                </ng-container>

                <ng-container matColumnDef="chargedAmount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Charged</th>
                    <td mat-cell *matCellDef="let element">{{formatAmount(element.chargedAmount)}}</td>
                </ng-container>

                <ng-container matColumnDef="pismoTrackingId">
                    <th mat-header-cell *matHeaderCellDef>Tracking ID</th>
                    <td mat-cell *matCellDef="let element" class="td-width ellipsis">{{element.pismoTrackingId || '-'}}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                    <td mat-cell *matCellDef="let element">
                        <span [ngClass]="getStatusClass(element.status)">{{element.status}}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="attemptCount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Attempts</th>
                    <td mat-cell *matCellDef="let element">{{element.attemptCount}} / {{element.maxAttempts}}</td>
                </ng-container>

                <ng-container matColumnDef="createdDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
                    <td mat-cell *matCellDef="let element">{{formatDate(element.createdDate)}}</td>
                </ng-container>

                <ng-container matColumnDef="lastAttemptDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Attempt</th>
                    <td mat-cell *matCellDef="let element">{{formatDate(element.lastAttemptDate)}}</td>
                </ng-container>

                <ng-container matColumnDef="errorMessage">
                    <th mat-header-cell *matHeaderCellDef>Error Message</th>
                    <td mat-cell *matCellDef="let element" class="td-width error-cell ellipsis-lines">
                        <span [matTooltip]="element.errorMessage || '-'"
                            [matTooltipDisabled]="!element.errorMessage || element.errorMessage.length <= 50">
                            {{element.errorMessage || '-'}}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        @if (showRetryButton(element)) {
                        <div fxLayout="row" fxLayoutAlign="end center">
                            <span class="mdi mdi-dots-vertical cursor-pointer" [matMenuTriggerFor]="menu"></span>
                        </div>
                        }
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item class="menu-items" (click)="retryCharge(element)">
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <div>Retry</div>
                                    <div><span class="mdi mdi-refresh"></span></div>
                                </div>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" class="expanded-row" [attr.colspan]="displayedColumns.length">
                        <div class="example-element-detail"
                            [@detailExpand]="element.id === expandedElementId ? 'expanded' : 'collapsed'">
                            <div class="row mt-3">
                                <div class="col-2 title">ID</div>
                                <div class="col-10">{{element.id}}</div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-2 title">Pismo Account ID</div>
                                <div class="col-10">{{element.pismoAccountId}}</div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-2 title">Period</div>
                                <div class="col-10">{{element.periodYearMonth}}</div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-2 title">Computed Amount</div>
                                <div class="col-10">{{formatAmount(element.computedAmount)}}</div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-2 title">Charged Amount</div>
                                <div class="col-10">{{formatAmount(element.chargedAmount)}}</div>
                            </div>
                            @if (element.pismoTrackingId) {
                            <div class="row mt-2">
                                <div class="col-2 title">Pismo Tracking ID</div>
                                <div class="col-10">{{element.pismoTrackingId}}</div>
                            </div>
                            }
                            <div class="row mt-2">
                                <div class="col-2 title">Status</div>
                                <div class="col-10">
                                    <span [ngClass]="getStatusClass(element.status)">{{element.status}}</span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-2 title">Attempt Count</div>
                                <div class="col-10">{{element.attemptCount}} / {{element.maxAttempts}}</div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-2 title">Created Date</div>
                                <div class="col-10">{{formatDate(element.createdDate)}}</div>
                            </div>
                            @if (element.lastAttemptDate) {
                            <div class="row mt-2">
                                <div class="col-2 title">Last Attempt Date</div>
                                <div class="col-10">{{formatDate(element.lastAttemptDate)}}</div>
                            </div>
                            }
                            @if (element.completedDate) {
                            <div class="row mt-2">
                                <div class="col-2 title">Completed Date</div>
                                <div class="col-10">{{formatDate(element.completedDate)}}</div>
                            </div>
                            }
                            @if (element.errorMessage) {
                            <div class="row mt-2">
                                <div class="col-2 title">Error Message</div>
                                <div class="col-10">{{element.errorMessage}}</div>
                            </div>
                            }
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns" class="example-element-row"
                    [class.example-expanded-row]="element.id === expandedElementId"
                    (click)="expandedElementId = element.id === expandedElementId ? null : element.id"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
            @if (total) {
            <app-custom-paginator [length]="total" [pageIndex]="offset" [pageSize]="limit"
                [pageSizeOptions]="[10, 20, 25, 50, 100]" (page)="onPagination($event)"></app-custom-paginator>
            }
        </div>
    </div>
</div>
